<template>
    <div class="select" @mouseleave="open = false">
        <a href="#" @click.prevent="open = !open">Selecionar Mês</a>
        <div class="select_options" v-show="open" :style="scrollStyle">
            <div class="scrollbar"></div>
            <ul ref="ul" @scroll="updateScroll">
                <li v-for="archive in archives" :key="archive.format">
                    <router-link :to="`/${archive.year}/${archive.month + 1}/`" v-text="archive.format">
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import api from '@/api'

    export default {
        name: 'FooterSelect',
        props: {
        },
        components: {
            // ScrollUpButton,
        },
        data() {
            return {
                open: false,
                archives: [],
                scrollWidth: 0,
                scrollHeight: 0,
                clientHeight: 0,
                scrollTop: 0,
            }
        },
        methods: {
            updateScroll() {
                this.scrollWidth = this.$refs.ul.offsetWidth - this.$refs.ul.clientWidth
                this.scrollHeight = this.$refs.ul.scrollHeight
                this.clientHeight = this.$refs.ul.clientHeight
                this.scrollTop = this.$refs.ul.scrollTop
            }
        },
        computed: {
            scrollStyle() {
                return {
                    "--scroll-width": `${this.scrollWidth}px`,
                    "--scroll-height": `${this.scrollHeight}`,
                    "--scroll-real-height": `${this.clientHeight}`,
                    "--scroll-top": `${this.scrollTop}`,
                }
            }
        },
        watch: {
            open() {
                this.$nextTick().then( () => {
                    this.updateScroll()
                })
            },
        },
        async mounted() {
            this.archives = await api.archive.all()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/colors';

$font-size: .75rem;
a {
  color: $color-white;
  text-decoration: none;
}

    .select {
        --scrollbar-width: 8px;

        font-size: $font-size;
        position: relative;

        > a {
            border: 2px solid $color-white;
            padding: 1em 1em calc(1em * .8);
            display: flex;

            &::after {
                content: '';
                background-image: url('@/assets/images/bullet.svg');
                height: 1em;
                width: .35em;
                display: block;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                padding: 0;
                margin: 0 0 0 .5em;
                transform: rotate(90deg);
            }
        }

        &_options {
            height: 20rem;
            overflow: hidden;
            position: absolute;
            bottom: calc(100% - 2px);
            width: 100%;
            z-index: 1000;
            border: 2px solid $color-white;
            filter: drop-shadow(0 0px 6px $color-betano);
        }
    }

    .scrollbar {
        position: absolute;
        height: calc( 100% * var(--scroll-real-height) / var(--scroll-height) );
        width: var(--scrollbar-width);
        top: calc( 100% * var(--scroll-top) / var(--scroll-height) );
        bottom: 0;
        right: 0;
        background-color: white;
        z-index: 1000;
    }


    ul {
        background-color: $color-betano;
        padding: 0;
        list-style: none;
        height: 100%;
        overflow: auto;
        width: calc(100% + 2rem);
        padding: 0 calc( 2rem - var(--scroll-width) + var(--scrollbar-width) ) 0 0;
        position: relative;

        li {
            padding: 0 !important;
            a {
                padding: 1em !important;
                width: 100%;
            }
            border-right: 2px solid $color-white;

            &::before {
                content: unset !important;
            }

            &:not(:last-child) {
                border-bottom: 1px solid $color-white;
            }
        }
    }
</style>
